import moment from 'moment';

const httpOptions = { withCredentials: true };

class TravelInvoicePreviewModalController {
  constructor($scope, $uibModalInstance, $http, $rootScope, $q, toastr, InvoiceService) {
    'ngInject';

    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.toastr = toastr;
    this.invoiceService = InvoiceService;
    this.moment = moment;

    $scope.invoiceLoaded = false;
    $scope.loadingError = false;
    $scope.companyLogoUri = null;
    $scope.categoryPreview = [];
    $scope.selectedExpenseReports = [];
    $scope.invoice = {
      customer: {},
      contract: {},
      project: {},
      company: {},
      invoiceDate: moment().toDate(),
      invoicePeriodStart: null,
      invoicePeriodEnd: null,
      invoiceNumberLabel: '',
      certification: '',
      signerName: '',
      signerTitle: '',
      signerEmail: '',
      signerPhone: ''
    };

    const recommendation = $uibModalInstance.invoiceRecommendation || {};
    $scope.recommendation = recommendation;

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.getPreviewTotal = function () {
      return ($scope.categoryPreview || []).reduce((total, row) => total + (row.currentCost || 0), 0);
    };

    $scope.getPreviewCumulativeTotal = function () {
      return ($scope.categoryPreview || []).reduce((total, row) => total + (row.cumulativeCost || 0), 0);
    };

    this.loadPreview(recommendation);
  }

  loadPreview(recommendation) {
    const self = this;
    const $scope = this.$scope;
    const api = this.$rootScope.apiHost;
    const projectId = recommendation.projectId;
    const expenseReportIds = (recommendation.expenseReportIds || []).map(Number);
    const priorCumulatives = {};

    if (!projectId || !expenseReportIds.length) {
      $scope.loadingError = true;
      this.toastr.error('Travel invoice recommendation is missing project or expense report details.', 'Error');
      return;
    }

    const periodStart = recommendation.invoicePeriodStart
      ? moment(recommendation.invoicePeriodStart).toDate()
      : moment().subtract(1, 'month').startOf('month').toDate();
    const periodEnd = recommendation.invoicePeriodEnd
      ? moment(recommendation.invoicePeriodEnd).toDate()
      : moment().subtract(1, 'month').endOf('month').toDate();

    $scope.invoice.invoicePeriodStart = periodStart;
    $scope.invoice.invoicePeriodEnd = periodEnd;
    $scope.invoice.invoiceDate = moment().toDate();

    const companyPromise = this.$http.get(`${api}/api/admin/companies/mycompany`, httpOptions);
    const mePromise = this.$http.get(`${api}/api/users/me`, httpOptions);
    const nextNumberPromise = this.$http.get(`${api}/api/admin/invoices/invnumber/next`, httpOptions);
    const reportsPromise = this.invoiceService.getTravelEligibleReports(projectId);
    const cumulativesPromise = this.invoiceService.getTravelCategoryCumulatives(projectId);
    const customerPromise = recommendation.customerId
      ? this.$http.get(`${api}/api/admin/customers/${recommendation.customerId}`, httpOptions)
      : this.$q.resolve({ data: { id: recommendation.customerId, name: recommendation.customerName } });
    const contractPromise = recommendation.contractId
      ? this.$http.get(`${api}/api/admin/contracts/${recommendation.contractId}`, httpOptions)
      : this.$q.resolve({ data: { id: recommendation.contractId, contractName: recommendation.contractName } });
    const projectPromise = this.$http.get(`${api}/api/admin/projects/${projectId}`, httpOptions);

    this.$q.all([
      companyPromise,
      mePromise,
      nextNumberPromise,
      reportsPromise,
      cumulativesPromise,
      customerPromise,
      contractPromise,
      projectPromise
    ]).then((results) => {
      const company = results[0].data || {};
      const user = results[1].data || {};
      const nextNumber = results[2].data;
      const reports = results[3].data || [];
      const cumulativeRows = results[4].data || [];
      const customer = results[5].data || {};
      const contract = results[6].data || {};
      const project = results[7].data || {};

      $scope.invoice.company = company;
      if (company.id) {
        $scope.companyLogoUri = `${api}/api/admin/companies/${company.id}/logo`;
      }

      $scope.invoice.signerName = ((user.firstName || '') + ' ' + (user.lastName || '')).trim();
      $scope.invoice.signerTitle = user.title || '';
      $scope.invoice.signerEmail = user.userName || user.email || '';
      $scope.invoice.signerPhone = user.phone || '';

      $scope.invoice.invoiceNumberLabel = nextNumber ? (nextNumber + '-TRAVEL') : '';
      $scope.invoice.customer = customer;
      $scope.invoice.contract = contract;
      $scope.invoice.project = project;
      $scope.invoice.certification = (contract && contract.invoiceStatement) || '';

      cumulativeRows.forEach((row) => {
        priorCumulatives[row.category] = row.priorCumulative || 0;
      });

      const selectedReports = reports.filter((report) => expenseReportIds.indexOf(Number(report.id)) >= 0);
      if (!selectedReports.length) {
        $scope.loadingError = true;
        self.toastr.error('Could not find the selected travel expense report for preview.', 'Error');
        return;
      }

      $scope.selectedExpenseReports = selectedReports;
      $scope.categoryPreview = self.buildCategoryPreview(selectedReports, priorCumulatives);
      $scope.invoiceLoaded = true;
    }, () => {
      $scope.loadingError = true;
      self.toastr.error('Could not load travel invoice preview.', 'Error');
    });
  }

  buildCategoryPreview(reports, priorCumulatives) {
    const totals = {};

    (reports || []).forEach((report) => {
      (report.categoryAmounts || []).forEach((row) => {
        const category = row.category || 'Other';
        totals[category] = (totals[category] || 0) + (row.amount || 0);
      });
    });

    return Object.keys(totals).sort((a, b) => a.localeCompare(b)).map((category) => {
      const current = Math.round((totals[category] || 0) * 100) / 100;
      const prior = priorCumulatives[category] || 0;
      return {
        category,
        currentCost: current,
        cumulativeCost: Math.round((prior + current) * 100) / 100
      };
    });
  }
}

export default TravelInvoicePreviewModalController;



// WEBPACK FOOTER //
// ./client/common/modals/TravelInvoicePreviewModal/travelInvoicePreviewModal.controller.js